import { useState } from 'react';
import { Box } from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
  keepMounted?: boolean;
}

export default function TabPanel(props: TabPanelProps) {
  const { children, value, index, keepMounted = false, ...other } = props;
  const active = value === index;

  // Adjusting state during render (rather than in an effect) so the panel
  // never renders a frame without its children on first activation.
  const [visited, setVisited] = useState(active);
  if (active && !visited) {
    setVisited(true);
  }

  const mounted = active || (keepMounted && visited);

  return (
    <Box component="div" hidden={!active} {...other}>
      {mounted && <Box>{children}</Box>}
    </Box>
  );
}
